import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import '../../css/Home.css'
import Signup from "./Signup";
import logo from "../../assets/ensoll-bg.png";
import {userSignIn} from "../../api/user";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import {Tooltip} from "@mui/material";
import {useNavigate} from "react-router-dom";
import Cookies from 'js-cookie';
import useAuth from "../../context/useAuth";
import RateLimiter from "../../utils/rateLimiter";

const Signin = () => {
    const rateLimiter = new RateLimiter(5, 15 * 60 * 1000); // 5 attempts per 15 minutes

    useEffect(() => {
        const switchers = [...document.querySelectorAll('.switcher')]

        switchers.forEach(item => {
            item.addEventListener('click', function () {
                switchers.forEach(item => item.parentElement.classList.remove('is-active'))
                this.parentElement.classList.add('is-active')
            })
        })

    }, []);
    const [values, setValues] = useState({
        username: '',
        password: ''
    });

    const {username, password} = values;

    const handleChange = name => event => {
        // Simple input sanitization to prevent XSS
        let value = event.target.value;
        
        // Remove any script tags and dangerous characters
        value = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
        value = value.replace(/javascript:/gi, '');
        value = value.replace(/on\w+\s*=/gi, '');
        
        // Limit length to prevent buffer overflow
        if (value.length > 50) {
            value = value.substring(0, 50);
        }
        
        setValues({...values, [name]: value});
    };

    const {setUser} = useAuth()
    const navigate = useNavigate();
    const clickLogin = event => {
        event.preventDefault();
        
        // Block empty submit
        if (!values.username || !values.password) {
            toast.error('Παρακαλώ εισάγετε όνομα χρήστη και κωδικό.');
            return;
        }
        
        // Check rate limiting
        const userKey = values.username || 'anonymous';
        if (!rateLimiter.isAllowed(userKey)) {
            const remainingTime = rateLimiter.getTimeUntilReset(userKey);
            const minutes = Math.ceil(remainingTime / (1000 * 60));
            toast.error(`Πάρα πολλές προσπάθειες σύνδεσης. Παρακαλώ δοκιμάστε ξανά σε ${minutes} λεπτά.`);
            return;
        }
        
        userSignIn(values)
            .then((res) => {
                    localStorage.setItem("token", res.data.token)
                    sessionStorage.setItem("token", res.data.token)
                    Cookies.set('user', JSON.stringify(res.data.user), {
                        expires: 1,
                        secure: true,
                        SameSite: 'Strict'
                    });
                    setUser(res.data.user)
                    navigate(res.data.user.role === 'user' ? "/entries" : "/");
                    toast.success(`Γεια σας ${res.data.user.username}, Καλώς ήρθατε!`);
                }
            )
            .catch((err) => {
                const remainingAttempts = rateLimiter.getRemainingAttempts(userKey);
                const errorMessage = err.response?.data?.error || err.message || 'Αποτυχία σύνδεσης';
                toast.error(`${errorMessage} (${remainingAttempts} προσπάθειες απομένουν)`);
            })
    };

    return (
        <div>
            <section className="forms-section">
                <div className="forms">
                    <div className="form-wrapper is-active">
                        <button type="button" className="switcher switcher-login">
                            Συνδεση
                            <span className="underline"></span>
                        </button>
                        <form className="form form-login">
                            <fieldset>
                                <img alt="logo"
                                     style={{maxWidth: "230px", height: "auto", padding: "20px"}}
                                     src={logo}
                                />
                                <div className="input-block" style={{width: '250px'}}>
                                    <label>Όνομα Χρήστη</label>
                                    <input id="login-username" onChange={handleChange('username')}
                                           value={username}
                                           type="text"
                                           placeholder="Όνομα Χρήστη"
                                           required/>
                                </div>
                                <div className="input-block" style={{width: '250px'}}>
                                    <label>Κωδικός</label>
                                    <input id="login-password" onChange={handleChange('password')}
                                           value={password}
                                           placeholder="Κωδικός"
                                           type="password" required/>
                                </div>
                                <a href="/forgot-password" style={{
                                    alignSelf: "start",
                                    fontSize: "14px",
                                    color: "rgba(187,187,187,1)"
                                }}>
                                    Ξέχασες τον κωδικό?
                                </a>
                            </fieldset>

                            <button type="button" onClick={clickLogin} className="btn-login">
                                Σύνδεση
                            </button>
                            <a href="/documentation.pdf"
                               download
                               style={{
                                   fontSize: "12px",
                                   color: "#1e6809",
                                   display: "block",
                                   margin: "30px 0 0 250px",
                               }}>
                                <Tooltip title={'Documentation'}>
                                    <FileOpenIcon/>
                                </Tooltip>
                            </a>
                        </form>
                    </div>
                    <div className="form-wrapper">
                        <button type="button" className="switcher switcher-signup">
                            Εγγραφη
                            <span className="underline"></span>
                        </button>
                        <Signup/>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Signin;
